import qs from "qs";
import { type LocationQuery, type LocationQueryRaw, createRouter, createWebHistory } from "vue-router";

import AdminRoutes from "@/enums/routes/AdminRoutes.ts";
import { tvRoutes } from "@/router/TvRouter.ts";
import { useAuthStore } from "@/stores/authStore.ts";

import BaseRoutes from "../enums/routes/BaseRoutes";
import { adminRoutes } from "./AdminRouter";
import { baseRoutes } from "./BaseRouter";
import { completionRoutes } from "./CompletionRouter";
import { expeditionRoutes } from "./ExpeditionRouter";
import { mixingRoutes } from "./MixingRouter";
import { palletCheckerRoutes } from "./PalletCheckerRouter";
import { pickingRoutes } from "./PickingRouter";

const adminRoutesNames: string[] = adminRoutes()[0].children!.map((route) => route.name as string);

const notFoundRoute = {
    path: "/:pathMatch(.*)*",
    component: () => import("../views/NotFound.vue"),
};

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        ...baseRoutes(),
        ...adminRoutes(),
        ...pickingRoutes(),
        ...mixingRoutes(),
        ...completionRoutes(),
        ...expeditionRoutes(),
        ...palletCheckerRoutes(),
        ...tvRoutes(),
        notFoundRoute,
    ],
    parseQuery(query: string): LocationQuery {
        // @ts-expect-error qs.parse() should fit into parseQuery() return value
        return qs.parse(query);
    },
    stringifyQuery(query: LocationQueryRaw): string {
        return qs.stringify(query);
    },
});

router.beforeEach((to) => {
    const authStore = useAuthStore();
    authStore.load();

    if (to.path === "/") {
        return { name: authStore.isAuthenticated ? AdminRoutes.DASHBOARD : BaseRoutes.SIGN_IN };
    } else if (to.name === BaseRoutes.SIGN_IN && authStore.isAuthenticated) {
        return { name: AdminRoutes.DASHBOARD };
    }

    if (typeof to.name === "string" && adminRoutesNames.includes(to.name)) {
        if (authStore.isAuthenticated) {
            return true;
        }
        return { name: BaseRoutes.SIGN_IN, query: { redirect: to.fullPath } };
    }
});

export default router;
